import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";

import storage from "redux-persist/lib/storage/session";
import reducer from "./reducer";

const persistConfig = {
  key: "root",
  version: 1,
  storage,
  whitelist: ["user", "config", "accounts"],
};

const persistedReducer = persistReducer(
  persistConfig,
  combineReducers(reducer)
);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export let persistor = persistStore(store);

export default store;

export type RootState = ReturnType<typeof store.getState>;
export type RootDispatch = typeof store.dispatch;

export type ThunkAPIConfig = {
  dispatch: RootDispatch;
  state: RootState;
};

export * from "./hooks";
